export default "__VITE_ASSET__DTbaiT96__"